import { jwtDecode } from 'jwt-decode';
import { redirect } from 'react-router-dom'
import { config } from '../config';

// The session token and current user are stored in localStorage. This module is
// the plain-JS access layer used by React Router loaders/actions and the repo
// layer (which run outside React). The AuthContext provider in
// src/store/auth-context.js mirrors the same keys into React state.
const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_USER_KEY = 'auth_user';

export function setAuthToken(token) {
  try {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
  } catch (error) {
    // Storage may be unavailable (private mode, disabled cookies/storage).
  }
}

export function getAuthToken() {
  let token = null
  try {
    token = localStorage.getItem(AUTH_TOKEN_KEY)
  } catch (error) {
    return null
  }

  if (!token) {
    return null
  }

  // Preserve the auto-expiry the cookie used to give us: an expired token is
  // treated as no token, and cleared.
  if (isTokenExpired(token)) {
    removeAuthToken()
    return null
  }

  return token
}

export function removeAuthToken() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY)
    localStorage.removeItem(AUTH_USER_KEY)
  } catch (error) {
    // Nothing to do if storage is unavailable.
  }
}

export function setStoredUser(user) {
  try {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user))
  } catch (error) {
    // Nothing to do if storage is unavailable.
  }
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token)
    if (!exp) {
      return false
    }
    return exp * 1000 <= Date.now()
  } catch (error) {
    // A token we cannot decode is not usable.
    return true
  }
}

export function checkSignedIn({request, params}) {
  if (!signedIn()) {
    const searchParams = new URL(request.url).searchParams
    const token = searchParams.get('token') || ''

    let url = '/sign_in'
    if (token !== '') {
      url = url + '?token=' + token + '&group_id=' + params.groupID;
    }

    return redirect(url);
  }

  return null;
}

export function checkNotSignedIn() {
  if (signedIn()) {
    return redirect('/');
  }

  return null;
}

export function signedIn() {
  const token = getAuthToken();

  if (!token) {
    return false;
  }

  return true;
}

export async function isAdmin() {
  const token = getAuthToken();

  if (!signedIn()) {
    return false;
  }

  const url = config.apiBaseUrl + `/rest/admin/`
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  return await response.ok
}


export function checkAdmin() {
  return isAdmin().then(
    response => {
      if (response) {
        return null
      } else {
        return redirect('/')
      }
    }
  )

  // alert(check)
  // if (check) {
  //   return null
  // } else {
  //   return redirect('/')
  // }
}
